import React, { createContext, useState, useEffect, useContext } from 'react';
import { authService } from '../services/dbService';

export const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        // Mock persistence check
        if (localStorage.getItem('mockAdminSession')) {
            setUser({ id: 'mock-admin-id', email: 'admin@degash.com', role: 'admin' });
            setIsAdmin(true);
            setLoading(false);
            return;
        }

        const unsubscribe = authService.onAuthStateChanged(async (u) => {
            if (localStorage.getItem('mockAdminSession')) return;
            if (u) {
                setUser(u);
                try {
                    const admin = await authService.isAdmin(u);
                    setIsAdmin(admin);
                } catch (err) {
                    console.error('Failed to check admin claim', err);
                    setIsAdmin(false);
                }
            } else {
                setUser(null);
                setIsAdmin(false);
            }
            setLoading(false);
        });

        return () => unsubscribe && unsubscribe();
    }, []);

    const login = async (email, password) => {
        setLoading(true);
        try {
            if (email === 'admin@degash.com' && password === 'Admin@123456') {
                localStorage.setItem('mockAdminSession', 'true');
                const adminUser = { id: 'mock-admin-id', email: 'admin@degash.com', role: 'admin' };
                setUser(adminUser);
                setIsAdmin(true);
                return adminUser;
            }
            
            const result = await authService.signIn(email, password);
            const u = result.user;
            const admin = await authService.isAdmin(u);
            setUser(u);
            setIsAdmin(admin);
            return u;
        } finally {
            setLoading(false);
        }
    };

    const logout = async () => {
        localStorage.removeItem('mockAdminSession');
        try {
            await authService.signOut();
        } catch (e) {}
        setUser(null);
        setIsAdmin(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, isAdmin, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};